export default "__VITE_ASSET__Bwj9F8iJ__"